export enum ActorFormTab {
  ThirdPartySelect = 'thirdPartiesSelect',
  ActorsDetails = 'actorsDetails',
  References = 'references',
  RepresentativesSelect = 'representativesSelect',
  RepresentativesDetails = 'representativesDetails',
}
